import { render, staticRenderFns } from "./UserReportResultsForm.vue?vue&type=template&id=d14fc006&"
import script from "./UserReportResultsForm.vue?vue&type=script&lang=js&"
export * from "./UserReportResultsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports